import { upload_image, upload_file } from "@/service/tools";
import { getPcdAll, findShopItem } from "@/service/user.js";

import router from "../router";
import { Message } from "ant-design-vue";
/*
 * 验证手机号是否合格
 * true--说明合格
 */
export function isPhone(phoneStr) {
  let myreg = /^[1][1,2,3,4,5,6,7,8,9][0-9]{9}$/;
  if (!myreg.test(phoneStr)) {
    return false;
  } else {
    return true;
  }
}

/*
  手机验证
  1. 中国电信号段 133、149、153、173、177、180、181、189、199
  2. 中国联通号段 130、131、132、145、155、156、166、175、176、185、186
  3. 中国移动号段 134(0-8)、135、136、137、138、139、147、150、151、152、157、158、159、178、182、183、184、187、188、198
 */
export function isvalidPhone(str) {
  let re = /^(13[0-9]|14[0-9]|15[0-9]|166|17[0-9]|18[0-9]|19[8|9])\d{8}$/
  if (!re.test(str)) {
    return false
  } else {
    return true
  }
}

/*
价格验证
  1. ^ [1-9]\d*(.\d{1,2})?$ ： 1-9 开头，后跟是 0-9，可以跟小数点，但小数点后要带上 1-2 位小数，类似 2,2.0,2.1,2.22 等

  2. ^ 0(.\d{1,2})?$ ： 0 开头，后可以跟小数点，小数点后要待上 1-2 位小数，类似 0,0.22,0.1 等

*/
export function isPrice(str) {
  const re = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/
  return re.test(str)
}


export function getShopInfo(callback) {
  findShopItem().then(res => {
    if (res.flag) {
      localStorage.setItem("amallShopInfo", JSON.stringify(res.data));
      callback(res);
    } else {
      Message({
        message: res.message,
        type: "error",
        duration: 3 * 1000
      });
    }
  });
}
/*
 * 验证身份证号是否合格
 * true--说明合格
 */
export function isIdCard(idCardStr) {
  let idcardReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
  if (idcardReg.test(idCardStr)) {
    return true;
  } else {
    return false;
  }
}
export function bankNumber_check(bankno) {
  if (bankno.length < 16 || bankno.length > 19) {
    // top.layer.msg('银行卡号长度必须在16到19之间',{icon: 2,time: 1000});
    return false;
  }
  var num = /^\d*$/; //全数字
  if (!num.exec(bankno)) {
    // top.layer.msg('银行卡号必须全为数字',{icon: 2,time: 1000});
    return false;
  }
  //开头6位
  var strBin =
    "10,18,30,35,37,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,58,60,62,65,68,69,84,87,88,94,95,98,99";
  if (strBin.indexOf(bankno.substring(0, 2)) == -1) {
    // top.layer.msg('银行卡号开头6位不符合规范',{icon: 2,time: 1000});
    return false;
  }
  var lastNum = bankno.substr(bankno.length - 1, 1); //取出最后一位（与luhm进行比较）

  var first15Num = bankno.substr(0, bankno.length - 1); //前15或18位
  var newArr = new Array();
  for (var i = first15Num.length - 1; i > -1; i--) {
    //前15或18位倒序存进数组
    newArr.push(first15Num.substr(i, 1));
  }
  var arrJiShu = new Array(); //奇数位*2的积 <9
  var arrJiShu2 = new Array(); //奇数位*2的积 >9

  var arrOuShu = new Array(); //偶数位数组
  for (var j = 0; j < newArr.length; j++) {
    if ((j + 1) % 2 == 1) {
      if (parseInt(newArr[j]) * 2 < 9) {
        arrJiShu.push(parseInt(newArr[j]) * 2);
      } else {
        arrJiShu2.push(parseInt(newArr[j]) * 2);
      }
    } else {
      arrOuShu.push(newArr[j]);
    }
  }

  var jishu_child1 = new Array(); //奇数位*2 >9 的分割之后的数组个位数
  var jishu_child2 = new Array(); //奇数位*2 >9 的分割之后的数组十位数
  for (var h = 0; h < arrJiShu2.length; h++) {
    jishu_child1.push(parseInt(arrJiShu2[h]) % 10);
    jishu_child2.push(parseInt(arrJiShu2[h]) / 10);
  }
  var sumJiShu = 0; //奇数位*2 < 9 的数组之和
  var sumOuShu = 0; //偶数位数组之和
  var sumJiShuChild1 = 0; //奇数位*2 >9 的分割之后的数组个位数之和
  var sumJiShuChild2 = 0; //奇数位*2 >9 的分割之后的数组十位数之和
  var sumTotal = 0;
  for (var m = 0; m < arrJiShu.length; m++) {
    sumJiShu = sumJiShu + parseInt(arrJiShu[m]);
  }

  for (var n = 0; n < arrOuShu.length; n++) {
    sumOuShu = sumOuShu + parseInt(arrOuShu[n]);
  }

  for (var p = 0; p < jishu_child1.length; p++) {
    sumJiShuChild1 = sumJiShuChild1 + parseInt(jishu_child1[p]);
    sumJiShuChild2 = sumJiShuChild2 + parseInt(jishu_child2[p]);
  }
  //计算总和
  sumTotal =
    parseInt(sumJiShu) +
    parseInt(sumOuShu) +
    parseInt(sumJiShuChild1) +
    parseInt(sumJiShuChild2);

  //计算Luhm值
  var k = parseInt(sumTotal) % 10 == 0 ? 10 : parseInt(sumTotal) % 10;
  var luhm = 10 - k;

  if (lastNum == luhm) {
    return true;
  } else {
    // top.layer.msg('验证失败',{icon: 2,time: 1000});
    return false;
  }
}
/*
 * 验证字符串是否为空（也不能为纯空格）
 * true--说明为空， false--说明不为空
 */
export function isEmptyString(string) {
  if (
    string == undefined ||
    typeof string == "undefined" ||
    !string ||
    string == null ||
    string == "" ||
    /^\s+$/gi.test(string)
  ) {
    return true;
  } else {
    return false;
  }
}
/*
 * timer 起始时间数组 格式  Wed Mar 10 2021 00:00:00 GMT+0800 (中国标准时间) {}
 * 起止日期时间转换
 * type  值为 true 返回时间格式为 yyyy-mm-dd hh:mm:ss  默认为 false
 * 返回  arr arr[0]开始时间 ：yyyy-mm-dd
 */
export function filterTimer(timer, type = false) {
  var arr = [];
  for (var item of timer) {
    var d = new Date(item);
    var year = d.getFullYear();
    var month = d.getMonth() + 1;
    var datas = d.getDate();
    if (month < 10) {
      month = "0" + month;
    }
    if (datas < 10) {
      datas = "0" + datas;
    }
    var time = year + "-" + month + "-" + datas;
    if (type) {
      if (arr.length == 0) {
        time += " 00:00:00";
        arr.push(time);
      } else if (arr.length == 1) {
        time += " 23:59:59";
        arr.push(time);
      }
    } else {
      arr.push(time);
    }
  }
  return arr;
}
/**
 * 验证是否为数字
 *
 * @export
 * @param {*} n
 * @return {*}
 */
export function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 *验证是否为整数字
 *
 * @param {*} obj
 * @return {*}
 */
export function isInteger(obj) {
  if (parseInt(obj) == obj) {
    //整数！
    if (parseInt(obj) >= 0) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}
/**
 *是否为数组
 *
 * @export
 * @param {*} obj
 * @return {*}
 */
export function isArray(obj) {
  return Object.prototype.toString.call(obj) === "[object Array]";
}
/**
 * 是否空数组
 *
 * @export
 * @param {*} val
 * @return {*}
 */
export function isArrayEmpty(val) {
  if (val && val instanceof Array && val.length > 0) {
    return false;
  } else {
    return true;
  }
}
/**
 *
 * @export
 * @param {*} name 获取url参数字符串
 * @return {*} 没有返回null
 */
export function getQueryString(name) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  let r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}
/**
 * 递归深拷贝  简单拷贝
 * 深拷贝其他简便方法 可以用.slice()  JSON的parse、stringify、obj1 = Object.assign({},obj)，这些方式仅仅适用于单层
 * 较复杂的对象该方法 不可用
 * @export
 * @param {*} obj
 * @return {*}
 */
export function deepCopy(obj) {
  if (typeof obj != "object" || obj == null) return obj;
  let result = Array.isArray(obj) ? [] : {};
  for (let key in obj) {
    // 优化 判断key是否是对象自身的属性，而不是对象原型属性
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === "object" && obj[key] !== null) {
        result[key] = deepCopy(obj[key]);
      } else {
        result[key] = obj[key];
      }
    }
  }
  return result;
}
export function copyText(text, callback) {
  // text: 要复制的内容， callback: 回调
  var tag = document.createElement("input");
  tag.setAttribute("id", "cp_hgz_input");
  tag.value = text;
  document.getElementsByTagName("body")[0].appendChild(tag);
  document.getElementById("cp_hgz_input").select();
  document.execCommand("copy");
  document.getElementById("cp_hgz_input").remove();
  if (callback) {
    callback(text);
  }
}
/**
 * @desc  函数防抖，用于将多次执行变为最后一次执行
 * @param {function} func - 需要使用函数防抖的被执行的函数。必传
 * @param {Number} wait - 多少毫秒之内触发，只执行第一次，默认1000ms。可以不传
 * @param {Number} immediate - 是否立即执行 默认为false
 */
export function debounce(fn, delay, immediate) {
  let timeout = null;
  return function () {
    let context = this;
    let arg = arguments;
    if (timeout) clearTimeout(timeout);
    if (immediate) {
      var callNow = !timeout;
      timeout = setTimeout(() => {
        timeout = null;
      }, delay);
      if (callNow) fn.apply(context, arg);
    } else {
      timeout = setTimeout(() => {
        fn.apply(context, arg);
      }, delay);
    }
  };
}
/**
 * 节流函数, 用于将多次执行变为每隔一段时间执行
 * @param fn 事件触发的操作
 * @param delay 间隔多少毫秒需要触发一次事件
 */
export function throttle2(fn, delay) {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    if (!timer) {
      timer = setTimeout(function () {
        fn.apply(context, args);
        clearTimeout(timer);
        timer = null;
      }, delay);
    }
  };
}

/**
 *  检测密码强度
 *
 * @export
 * @param {*} str 字符串
 * @return {*} @returns 1：密码弱 2：密码中等 3：密码强 4：密码很强
 */
export function checkPwd(str) {
  var nowLv = 0;
  if (str.length < 6) {
    return nowLv;
  }
  if (/[0-9]/.test(str)) {
    nowLv++;
  }
  if (/[a-z]/.test(str)) {
    nowLv++;
  }
  if (/[A-Z]/.test(str)) {
    nowLv++;
  }
  // if (/[\.|-|_]/.test(str)) {
  //     nowLv++
  // };
  return nowLv;
}

/*
 *
 * 返回指定某个区间的一个数字（可以不传参，不传就返回0-255之间的数；可以只传一个，返回0到传入的这个数字之间的某个值）
 * @param n1 开始区间 例：5
 * @param n2 结束区间 例：10
 * @returns 返回这个区间的某个随机值
 */
export function randomNumber(n1, n2) {
  if (arguments.length === 2) {
    return Math.round(n1 + Math.random() * (n2 - n1));
  } else if (arguments.length === 1) {
    return Math.round(Math.random() * n1);
  } else {
    return Math.round(Math.random() * 255);
  }
}
/*
 *
 * 随机产生某个颜色
 * @returns {String} 颜色 例：rgb(250,82,49)
 */
export function randomColor() {
  //randomNumber是上面定义的函数
  //写法1
  return (
    "rgb(" +
    randomNumber(255) +
    "," +
    randomNumber(255) +
    "," +
    randomNumber(255) +
    ")"
  );

  //写法2
  // return '#' + Math.random().toString(16).substring(2).substr(0, 6);

  //写法3
  // var color = '#';
  // for (var i = 0;
  //     i < 6;
  //     i++) {
  //     color += '0123456789abcdef'[ this.randomNumber(15) ];
  // }
  // return color;
}
/*
 *
 * 数组去重
 * 用的是Array的from方法
 * @param arr 数组
 * @returns 去重后的数组
 */
export function removeRepeatArray(arr) {
  return Array.from(new Set(arr));
}

/*
 *
 * 获取全国省市区方法
 * @param type 是否需要返回区/县 0.否 1.是
 */
export function getAllPositionArea(type = 1) {
  return new Promise((resolve, reject) => {
    getPcdAll({
      type
    }).then(res => {
      let arr = [];
      for (var item of res.data) {
        let objects = {
          label: "",
          value: "",
          children: []
        };
        for (let it in item) {
          objects.label = it;
          objects.value = it;
          for (var i of item[it]) {
            let obj = {
              label: "",
              value: "",
              children: []
            };
            obj.label = i.name;
            obj.value = i.id;
            objects.children.push(obj);
            if (i.areaList) {
              for (var j of i.areaList) {
                let o = {
                  label: "",
                  value: ""
                };
                o.label = j.name;
                o.value = j.id;
                obj.children.push(o);
              }
            }
          }
        }
        arr.push(objects);
      }
      resolve(arr);
    });
  });
}

/*
 *
 * 上传图片文件
 * @param type 文件类型 image:图片  file:文件
 * @returns
 */
export function uploadFile(type, file) {
  return new Promise((resolve, reject) => {
    if (type == "image") {
      var formData = new FormData();
      formData.append(type + "", file);

      upload_image(formData).then(res => {
        if (res.flag) {
          resolve(res.data);
        } else {
          Message({
            message: res.message,
            type: "error",
            duration: 3 * 1000
          });
        }
        return;
      });
    } else {
      var formData = new FormData();
      formData.append(type + "", file);
      console.log(formData);
      upload_file(formData).then(res => {
        // console.log(res);
        if (res.flag) {
          resolve(res.data);
        } else {
          Message({
            message: res.message,
            type: "error",
            duration: 3 * 1000
          });
        }
        return;
      });
    }
  });
}
/** 图片压缩，默认同比例压缩
 *  @param {Object} fileObj
 *  图片对象
 *  回调函数有一个参数，base64的字符串数据
 */
export function compress(fileObj, callback) {
  try {
    const image = new Image();
    image.src = URL.createObjectURL(fileObj);
    image.onload = function () {
      const that = this;
      // 默认按比例压缩
      let w = that.width;
      let h = that.height;
      const scale = w / h;
      w = fileObj.width || w;
      h = fileObj.height || w / scale;

      let quality = 0.5; // 默认图片质量为0.7
      if (fileObj.size / 1024 / 1024 > 1) {
        quality = 0.3;
      }
      if (fileObj.size / 1024 / 1024 > 5) {
        quality = 0.1;
      }
      if (fileObj.size / 1024 / 1024 > 10) {
        quality = 0.02;
      }

      // 生成canvas
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      // 创建属性节点
      const anw = document.createAttribute("width");
      anw.nodeValue = w;
      const anh = document.createAttribute("height");
      anh.nodeValue = h;
      canvas.setAttributeNode(anw);
      canvas.setAttributeNode(anh);
      ctx.fillStyle = "white";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(that, 0, 0, w, h);
      // quality值越小，所绘制出的图像越模糊
      const data = canvas.toDataURL("image/jpeg", quality);
      // 压缩完成执行回调
      const newBold = convertBase64UrlToBlob(data, fileObj.name);
      callback(newBold);
    };
  } catch (e) {
    console.log("压缩失败!");
  }
}

function convertBase64UrlToBlob(dataurl, fileName) {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], fileName, {
    type: mime,
    name: fileName,
    lastModifiedDate: new Date()
  });
}

/*
 *
 * 登出
 * @param type 文件类型 image:图片  file:文件
 * @returns
 */
export function loginOut() {
  localStorage.removeItem("amallSystemId");
  localStorage.removeItem("amall_defult_select_keys");
  localStorage.removeItem("amall_defult_open_keys");
  localStorage.removeItem("amallShopInfo");

  if (localStorage.getItem("amallShopType") == 2) {
    localStorage.removeItem("amallShopType");
    router.push({
      path: "/demandLogin"
    });
  } else {
    localStorage.removeItem("amallShopType");
    router.push({
      path: "/login"
    });
  }
}
export function getShoppType() {
  return localStorage.getItem("amallShopType")
    ? localStorage.getItem("amallShopType")
    : 1;
}
/*
 *
 * 清空登录信息
 * @param type 文件类型 image:图片  file:文件
 * @returns
 */
export function clearLoginInfo() {
  localStorage.removeItem("amallSystemId");
  localStorage.removeItem("amall_defult_select_keys");
  localStorage.removeItem("amall_defult_open_keys");
  localStorage.removeItem("amallShopInfo");
  sessionStorage.removeItem("token");
  localStorage.removeItem("token");

  sessionStorage.removeItem("userInfo");
  localStorage.removeItem("userInfo");

  sessionStorage.removeItem("suitId");
  localStorage.removeItem("suitId");

  sessionStorage.removeItem("shop_status");
  localStorage.removeItem("shop_status");

  sessionStorage.removeItem("select_position");
  localStorage.removeItem("select_position");

  sessionStorage.removeItem("shopInfo");
  localStorage.removeItem("shopInfo");

  sessionStorage.removeItem("group_confirm_order");
  localStorage.removeItem("group_confirm_order");

  sessionStorage.removeItem("im_selectOrder");
  localStorage.removeItem("im_selectOrder");

  sessionStorage.removeItem("userMenuList");
  localStorage.removeItem("userMenuList");
  localStorage.removeItem("shouserMenuListpInfo");

  sessionStorage.removeItem("vipInfo");
  localStorage.removeItem("vipInfo");

  sessionStorage.removeItem("defaultActiveUrl");
  localStorage.removeItem("defaultActiveUrl");

  sessionStorage.removeItem("selectOrder");
  localStorage.removeItem("selectOrder");

  sessionStorage.removeItem("orderInfos");
  localStorage.removeItem("orderInfos");
}

export function getPCtoken() {
  var canvas = document.createElement("canvas");
  var ctx = canvas.getContext("2d");
  var txt = "http://security.tencent.com/";
  ctx.textBaseline = "top";
  ctx.font = "14px 'Arial'";
  ctx.textBaseline = "tencent";
  ctx.fillStyle = "#f60";
  ctx.fillRect(125, 1, 62, 20);
  ctx.fillStyle = "#069";
  ctx.fillText(txt, 2, 15);
  ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
  ctx.fillText(txt, 4, 17);

  var b64 = canvas.toDataURL().replace("data:image/png;base64,", "");
  var bin = atob(b64);
  var crc = bin2hex(bin.slice(-16, -12));
  //var crc = bin.slice(-16,-12);
  return crc;
}
export function bin2hex(str) {
  var result = "";
  for (var i = 0; i < str.length; i++) {
    result += int16_to_hex(str.charCodeAt(i));
  }
  return result;
}
export function int16_to_hex(i) {
  var result = i.toString(16);
  var j = 0;
  while (j + result.length < 4) {
    result = "0" + result;
    j++;
  }
  return result;
}

export function switchTimeFormat(time, type) {
  const dateTime = new Date(time);
  const year = dateTime.getFullYear();
  const month = dateTime.getMonth() + 1;
  const date = dateTime.getDate();
  const hour = dateTime.getHours();
  const minute = dateTime.getMinutes();
  const second = dateTime.getSeconds();
  if (!type) {
    return year + "-" + addZero(month) + "-" + addZero(date);
  } else {
    return (
      year +
      "-" +
      addZero(month) +
      "-" +
      addZero(date) +
      " " +
      addZero(hour) +
      ":" +
      addZero(minute) +
      ":" +
      addZero(second)
    );
  }
}
export function addZero(v) {
  return v < 10 ? "0" + v : v;
}
/*
 * 验证是否为金额格式
 * 返回 true 符合金额格式
 * 返回 false 输入数字不符合金额
 */
export function checkMoney(value) {
  var amount = value;
  if (amount != null && amount != "") {
    var exp = /^(([1-9]\d*)|\d)(\.\d{1,2})?$/;
    if (!exp.test(amount)) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
}
/*
 * 验证是否为金额格式  //带小数
 * 返回 true 符合金额格式
 * 返回 false 输入数字不符合金额
 */
export function checkMoney1(value) {
  var isNum = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
  if (isNum.test(value)) {
    return true;
  } else {
    return false;
  }
}
/*
 * 获取当前百度地图经纬度
 * 获取当前百度地图位置
 */
export function getPosition(lng) {
  return new Promise((resolve, reject) => {
    //定义获取城市方法
    const geolocation = new BMap.Geolocation();
    geolocation.getCurrentPosition(
      function getinfo(position) {
        let city = position.address.city; //获取城市信息
        let province = position.address.province; //获取省份信息
        if (lng) {
          resolve(position.point);
        } else {
          resolve({
            province,
            city
          });
        }
      },
      function (e) {
        resolve({});
      },
      {}
    );
  });
}

/*
 * 复杂数组去重 将数组中每一个对象中 type 属性相同的的去重
 * array 所需处理的数组
 * type  数组包含对象中的 判断所需用到的键
 */
// 数据合并  array:需合并的数据
function arrMerge(array, type) {
  // 保存新数组
  let newArr = [];
  array.forEach(item => {
    // 保存判断结果
    let res = newArr.isExist(item.type, type);
    // 若不存在新数组中，则直接追加进新数组
    if (res == -1) {
      newArr.push(item);
    } else {
      item.firstLetter = "";
      newArr.push(item);
    }
  });
  return newArr;
}
// 判断元素是否存在数组中对象属性中  value:元素   key:对象属性
Array.prototype.isExist = function (value, key) {
  for (let i = 0, len = this.length; i < len; i++) {
    // 若存在，则返回对应的索引
    if (this[i][key] === value) {
      return i;
    }
  }
  // 否则返回 -1
  return -1;
};
/**
 * 用于判断空，Undefined String Array Object Number boolean
 */
export function isNull(str) {
  if (Object.prototype.toString.call(str) === "[object Undefined]") {
    //空
    return true;
  } else if (Object.prototype.toString.call(str) === "[object String]") {
    //字条串或数组
    return str.trim().length == 0 ? true : false;
  } else if (Object.prototype.toString.call(str) === "[object Array]") {
    return str.length == 0 ? true : false;
  } else if (Object.prototype.toString.call(str) === "[object Object]") {
    return JSON.stringify(str) == "{}" ? true : false;
  } else if (typeof str == "number") {
    //Number 型
    if (str) {
      return false;
    } else {
      //数字0 不算空
      if (str == 0) {
        return false;
      }
      return true;
    }
  } else if (typeof str == "boolean") {
    if (!param) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }
}

export function arrayBufferToBase64Img(buffer) {
  const str = String.fromCharCode(...new Uint8Array(buffer));
  return `data:image/jpeg;base64,${window.btoa(str)}`;
}
/*
 *
 * 导出文件链接
 * @param url 文件url
 * @returns
 */
export function exportTable(url) {
  let a = document.createElement("a");
  a.href = url; // 这里的请求方式为get，如果需要认证，接口上需要带上token
  a.click();
  document.body.removeChild(a);
}

export function editMenuList(rows, callback) {
  let shopType = localStorage.getItem("amallShopType");
  let menu = [];
  if (shopType && shopType == 1) {
    rows.forEach(item => {
      let obj = {
        value: item.value,
        isWorkOrder: item.isWorkOrder,
        lable: item.lable,
        icon: item.icon,
        children: []
      };
      item.children.forEach(it => {
        if (it.value == "/Aicontrol_project") {
        } else {
          obj.children.push(it);
        }
      });
      menu.push(obj);

    });
    callback(menu, shopType);
  } else if (shopType && shopType == 2) {
    // console.log('rows',rows);
    rows.forEach(item => {
      if (item.isWorkOrder) {
        let obj = {
          value: item.value,
          isWorkOrder: item.isWorkOrder,
          lable: item.lable,
          icon: item.icon,
          children: []
        };
        item.children.forEach(it => {
          if (it.isWorkOrder) {
            obj.children.push(it);
          }
        });
        menu.push(obj);
      }
    });
    callback(menu, shopType);
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js